var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1406C13.6569 15.1406 15 13.7975 15 12.1406C15 10.4838 13.6569 9.14062 12 9.14062C10.3431 9.14062 9 10.4838 9 12.1406C9 13.7975 10.3431 15.1406 12 15.1406Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6224 10.536L18.5247 7.88542L20 6.14062L18 4.14062L16.2647 5.62358L13.5578 4.51036L12.9353 2.14062H10.981L10.3491 4.54175L7.70441 5.65659L6 4.14062L4 6.14062L5.45337 7.92947L4.3725 10.587L2 11.1406V13.1406L4.40111 13.7961L5.51575 16.4404L4 18.1406L6 20.1406L7.79116 18.6809L10.397 19.753L11 22.1406H13L13.6045 19.7538L16.2551 18.6562C16.6969 18.9719 18 20.1406 18 20.1406L20 18.1406L18.5159 16.39L19.6139 13.7386L21.9999 13.1178L22 11.1406L19.6224 10.536Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f07d3dd2cd0ce374e6a880473b5d240d.svg";
export { ForwardRef as ReactComponent };